import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { merge, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OtpService } from '../otp/otp.service';
import { ErrorService } from './error.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(
    private errorHandler: ErrorService,
    private otpService: OtpService
  ) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const status = err?.status;
        if (err?.error?.errorCode === 6) {
          this.otpService.response = err;
          this.otpService.status = status;
          this.otpService.request =
            status === 403 || status === 410 ? null : request;

          if (request.headers.has('x-otp')) {
            return of({});
          } else {
            return merge(
              this.otpService.complete$,
              this.otpService.cancel$
            ).pipe(
              map((res) =>
                // Cast null or error responses to HttpResponse so the observable can complete
                !(res instanceof HttpResponse)
                  ? new HttpResponse({
                      ...(err ?? {}),
                      ...(res ?? {}),
                    })
                  : res
              )
            );
          }
        }
        return this.errorHandler.handleHttpErrorResponse(err);
      })
    );
  }
}
